import * as yup from 'yup';

export const schema = yup
  .object({
    descricao: yup.string().required(),
    tipoDados: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    regex: yup.string().notRequired().nullable(true),
  })
  .required();
